import React from 'react'

function StatisticsCard({ 
    title, 
    count, 
    icon, 
    borderColor = 'border-blue-500', 
    textColor = 'text-blue-500',
    countColor = 'text-gray-900',
    bgGradient = 'from-blue-50 to-blue-100/50',
    iconBgColor = 'bg-blue-500'
}) {
    return (
        <div className={`
            group relative bg-white rounded-xl border border-gray-200/60 
            shadow-sm hover:shadow-lg transition-all duration-300 ease-in-out
            hover:border-gray-300/80 hover:-translate-y-1 overflow-hidden
        `}>
            {/* Gradient background overlay */}
            <div className={`absolute inset-0 bg-gradient-to-br ${bgGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
            
            {/* Left accent border */}
            <div className={`absolute left-0 top-0 bottom-0 w-1 ${borderColor.replace('border-', 'bg-')} rounded-l-xl`}></div>
            
            {/* Content */}
            <div className="relative p-6">
                <div className="flex items-center justify-between">
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-3">
                            {/* Icon container */}
                            <div className={`
                                flex-shrink-0 w-12 h-12 rounded-lg 
                                ${iconBgColor.includes('bg-') ? iconBgColor : `bg-${iconBgColor}`}
                                shadow-lg flex items-center justify-center
                                group-hover:scale-110 transition-transform duration-300
                            `}>
                                <div className="text-white">
                                    {icon}
                                </div>
                            </div>
                            
                            {/* Text content */}
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide truncate">
                                    {title}
                                </p>
                                <div className="mt-1 flex items-baseline">
                                    <p className={`text-3xl font-bold ${countColor} tracking-tight`}>
                                        {count}
                                    </p>
                                    <div className={`ml-2 w-2 h-2 rounded-full ${borderColor.replace('border-', 'bg-')} opacity-60`}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Bottom highlight line */}
                <div className={`
                    absolute bottom-0 left-0 right-0 h-0.5 
                    ${borderColor.replace('border-', 'bg-')} 
                    transform scale-x-0 group-hover:scale-x-100 
                    transition-transform duration-300 origin-left
                `}></div>
            </div>
        </div>
    )
}

export default StatisticsCard